import { react2angular } from '@/react-tools/react2angular';

import { NetworkDetailsView } from './NetworkDetailsView';

export const NetworkDetailsViewAngular = react2angular(NetworkDetailsView, []);
